import Chart from './Chart';
import Header from './Header';
import DataError from './DataError';
import RiskSignals from './RiskSignals';
import MetricCards from './MetricCards';
import AppLayout from '../../components/AppLayout';
import ActivityAndDeadline from './ActivityAndDeadline';
import useDashboardFunctions from './useDashboardFunctions';

const DashboardScreen = ({ socket: globalSocket }) => {
  const {
    t,
    history,
    loading,
    dataError,
    lastUpdated,
    riskSummary,
    ackingId,
    logsList,
    onlineUsers,
    liveActivity,
    upcomingDeadlines,
    reggieCount,
    signalFlash,
    metricFlash,
    fetchDashboard,
    handleAcknowledge,
    openClaims,
    avgCycleDays,
    pendingReviews,
    complianceScore,
    liveStatusData,
    totalClaimsLive,
    liveVolumeData,
    volumeRangeLabel,
    claimsEnabled,
  } = useDashboardFunctions(globalSocket);

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
        {/* ── Header ──────────────────────────────────────── */}
        <Header onlineUsers={onlineUsers} reggieCount={reggieCount} lastUpdated={lastUpdated} fetchDashboard={fetchDashboard} metricFlash={metricFlash} t={t} />

        <div style={{ flex: 1, padding: '24px 32px', display: 'flex', flexDirection: 'column', gap: 24, minHeight: 0 }}>
          {/* ── Data error banner ────────────────────────── */}
          <DataError t={t} dataError={dataError} fetchDashboard={fetchDashboard} />

          {/* Metric cards + charts only render for tenants that have the
              Claims feature enabled. A tenant without claims sees the
              risk signals + activity row only — no phantom widgets. */}
          {claimsEnabled && (
            <>
              {/* ── Metric Cards ─────────────────────────── */}
              <MetricCards
                t={t}
                loading={loading}
                openClaims={openClaims}
                metricFlash={metricFlash}
                avgCycleDays={avgCycleDays}
                pendingReviews={pendingReviews}
                complianceScore={complianceScore}
              />

              {/* ── Charts Row ───────────────────────────── */}
              <Chart t={t} liveStatusData={liveStatusData} totalClaimsLive={totalClaimsLive} liveVolumeData={liveVolumeData} volumeRangeLabel={volumeRangeLabel} />
            </>
          )}

          {/* ── Bottom Row: Activity + Deadlines ─────────── */}
          <ActivityAndDeadline t={t} history={history} liveActivity={liveActivity} logsList={logsList} upcomingDeadlines={upcomingDeadlines} />

          {/* ── Risk Signals Widget ───────────────────────── */}
          {(() => {
            const sev = riskSummary?.bySeverity || {};
            const critical = sev.critical || 0;
            const high = sev.high || 0;
            const medium = sev.medium || 0;
            const low = sev.low || 0;
            const signals = riskSummary?.recentSignals || [];
            const hasData = riskSummary !== null;

            const displaySignals = hasData ? signals : [];
            const displayCritical = hasData ? critical : '—';
            const displayHigh = hasData ? high : '—';
            const displayMedium = hasData ? medium : '—';

            return (
              <RiskSignals
                t={t}
                history={history}
                displaySignals={displaySignals}
                handleAcknowledge={handleAcknowledge}
                displayCritical={displayCritical}
                displayHigh={displayHigh}
                displayMedium={displayMedium}
                signalFlash={signalFlash}
                hasData={hasData}
                low={low}
                loading={loading}
                ackingId={ackingId}
              />
            );
          })()}
        </div>
      </div>
    </AppLayout>
  );
};

export default DashboardScreen;
